module.exports = __webpack_public_path__ + "static/media/1.cdc61f26.webp";